<template>
    <section>
        <h1 class="mb-0 mt-5 mb-3 text-center">Subjects</h1>

        <v-row>
            <v-col>
                <v-text-field
                        v-model="keyword"
                        label="Search"
                        hide-details
                >
                    <template v-slot:prepend-inner>
                        <svg v-svg="'icon-search'" size="15"></svg>
                    </template>
                </v-text-field>
            </v-col>
        </v-row>

        <v-data-table :headers="headers"
                      :items="subjects"
                      :page.sync="pagination.current"
                      :items-per-page="pagination.rowsPerPage"
                      hide-default-footer
                      class="elevation-1 mt-13 mb-6"
                      mobile-breakpoint="0"
        >
            <template v-slot:item.id="props">
                {{(pagination.current - 1)*pagination.rowsPerPage+props.index+1}}
            </template>

            <template v-slot:item.actions="props">
                <v-btn text class="px-0 mr-1" @click="[$refs.edit.dialog = true, selectedSubject = props.item.id]">
                    <svg v-svg="'icon-edit'" size="12" class="mr-1"></svg>
                    <span class="green--text">Edit</span>
                </v-btn>

                <v-btn text class="px-0 mx-2" @click="[$refs.delete.dialog = true, selectedSubject = props.item.id]">
                    <svg v-svg="'icon-delete'" size="12" class="mr-1"></svg>
                    <span class="red--text">Delete</span>
                </v-btn>

                <v-btn text class="px-0 mx-1 lessons" :to="{name : 'AdminLessons', query: {subject_id : props.item.id}}">
                    <svg v-svg="'icon-lesson'" size="12" fill="currentColor" class="mr-1"></svg>
                    <span>Lessons</span>
                </v-btn>

                <v-btn text class="px-0 ml-2 quizzes" :to="{name : 'AdminQuizzes', query: {subject_id : props.item.id}}">
                    <svg v-svg="'icon-quiz'" size="12" fill="currentColor" class="mr-1"></svg>
                    <span>Quizzes</span>
                </v-btn>
            </template>

            <template v-slot:header.actions class="d-none"></template>
        </v-data-table>

        <div class="float-end mb-5">
            <v-pagination  v-model="pagination.current"
                           :length="pagination.total"
                           :total-visible="3"
                           color="green"
                           @input="getData"
            ></v-pagination>
        </div>

        <v-btn color="green" width="52" height="52" class="create" fab fixed bottom @click="$refs.create.dialog = true">
            <svg v-svg="'icon-create'" size="21"></svg>
        </v-btn>

        <edit ref="edit" :subject_id="selectedSubject"></edit>
        <delete ref="delete" :subject_id="selectedSubject"></delete>
        <create ref="create"></create>
    </section>
</template>

<script>
    import Edit from '@/components/Admin/Subjects/Edit';
    import Delete from '@/components/Admin/Subjects/Delete';
    import Create from '@/components/Admin/Subjects/Create';
    export default {
        components : {
            Edit,
            Delete,
            Create,
        },
        data(){
            return {
                timeout: null,
                loadingRequest: false,
                selectedSubject: null,
                keyword: null,
                headers: [
                    {text: '#ID', sortable: false, value: 'id'},
                    {text: 'Name', sortable: false, value: 'name'},
                    {text: 'Actions', sortable: false, value: 'actions', align: 'right'}
                ],
                pagination: {},
                subjects: [],
            }
        },

        mounted(){
            this.getData();
            this.$on('getSubjects', function () {
                this.getData();
            })
        },

        watch: {
            keyword() {
                clearTimeout(this.timeout);
                this.timeout = setTimeout(() => {
                    this.getData(1);
                }, 300);
            }
        },

        methods: {
            getData(page) {
                this.loadingRequest = true;
                this.$apiAdmin('subjects').get({params: {page: page, keyword: this.keyword}}).then((res) => {
                    const response = res.data.courses;
                    this.pagination.rowsPerPage = response.per_page;
                    this.pagination.current = response.current_page;
                    this.pagination.total = response.last_page;
                    this.subjects = response.data;
                }).finally(() => {
                    this.loadingRequest = false;
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../scss/pages/tablePages";
    @import "../../../scss/pages/Subjects/index";
</style>